<template>
    <el-drawer class="queue-menu-drawer" v-model="drawerVisible" :title="t('queueMenu')" :size="450">
      <el-form v-if="drawerVisible" @submit.prevent="">
        <CustomersQueue :shortView="true" @addCustomer="addCustomer"/>
      </el-form>
    </el-drawer>
    
    <button type="button" @click="drawerVisible = true" class="rounded-xl border border-input bg-input p-1 text-sm ring-offset-background focus:outline-none focus:ring-1 focus:ring-ring focus:ring-offset-0">
        <Icon icon="ic:twotone-monitor" width="24" height="24" />
    </button>
</template>

<script lang="ts" setup>
import { Icon } from '@iconify/vue/dist/iconify.js';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import CustomersQueue from '../customers/CustomersQueue.vue';
import Customer from '@/models/customer/Customer';

const emits = defineEmits(['addCustomer'])

const messages = {
  en: {
    queueMenu: 'Queue Menu',
  },
  ar: {
    queueMenu: 'قائمة الانتظار',
  }
}

const { t } = useI18n({ messages, useScope: 'global' })

const drawerVisible = ref(false)

const addCustomer = (customer: Customer) => {
  emits('addCustomer', customer)
}
</script>

<style scoped>

</style>